/**
 * CalEventRow — single labeled text input row for CalEventDialog.
 * Minimal, self-contained — no dependency on JInspector components.
 * @param {object} props
 * @param {string} props.label
 * @param {string} props.value
 * @param {function} props.onChange - fn(newValue)
 * @param {boolean} props.multiline - renders a textarea instead of input
 */
export default function CalEventRow({ label, value, onChange, multiline = false }) {
    return (
        <div className="ce-row">
            <span className="ce-label">{label}</span>
            {multiline ? (
                <textarea
                    className="ce-textarea"
                    value={value || ''}
                    onChange={(e) => onChange(e.target.value)}
                    rows={2}
                />
            ) : (
                <input
                    className="ce-input"
                    type="text"
                    value={value || ''}
                    onChange={(e) => onChange(e.target.value)}
                />
            )}
        </div>
    );
}
